export default __webpack_public_path__ + "assets/b439e7.svg";